import React from "react"
import ReactDOM from 'react-dom'
import Ample from "../components/ample"
import {formatCurrency, formatPct, validateNumericInput, validateStringInput} from "../components/utils"
import ctPartialArea from "../plugins/bower_components/chartist/partial-area"
import ChainPicker from "../components/chainpicker"
import TextField from '@material-ui/core/TextField';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExplainerPopover from "../components/explainerpopover"
import { OutboundLink } from "gatsby-plugin-google-gtag"
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {OptionType,OptionStrategy,optionName,strategyName} from "../data/options"
import "../plugins/bower_components/chartist/chartist.min.css"
import "../css/chartist_overrides.css"


export default class SpreadFinderPage extends React.Component {
  state = {
    selected_ticker: "KSS",
    selected_expiry: "",
    strikewidth: 5.0,
    resultsVisible : false,
    optiondata: [],
    pricedata: null,
    selectedSpread: 0,
    backdropActive:false,    
    displayed_ticker: "KSS",
    displayed_expiry: "", 
    selected_option_type:OptionType.Call, 
    selected_strategy:OptionStrategy.DebitSpread
  }


  
  
  

  // #region option / strategy types

  strategyChanged = event => { 
    this.setState({selected_strategy:event.target.value})
  }
  // #endregion


  // #region form events
  strikeWidthChanged= event => {
    this.setState({strikewidth:event.target.value})
  }

  activateBackdrop = () => {
    this.setState({backdropActive:true})
  }
  closeBackdrop = () => {
    this.setState({backdropActive:false})
  }
  formValid() { 
    const valid = (validateStringInput(this.state.selected_ticker.toString())
    && validateStringInput(this.state.selected_expiry.toString() )
    && validateNumericInput(this.state.strikewidth,false,false)
    )
    return valid;
    
  }
  formReset = event => {
    this.setState({resultsVisible:false})
  }
  formSubmitted = event => {
    this.activateBackdrop()
    this.setState({optiondata:[],resultsVisible:false})

    //make sure both calls are against the same ticker (in case the drop-down changes in between)
    let ticker = this.state.selected_ticker
    let expiry = this.state.selected_expiry
    let width = this.state.strikewidth
    let option_type=this.state.selected_option_type
    let strategy=this.state.selected_strategy
    Promise.all([this.requestOptionData(ticker,expiry,width,option_type,strategy),this.requestPriceData(ticker)])
      .then(()=>{
        this.sortData(this.SortMode.bottomStrike)
        this.selectSpread(this.determineDefaultSelectedSpread()) //this will cause re-render
        this.setState({resultsVisible:true})
      }).then ( ()=> {this.closeBackdrop()} )

  }
  // #endregion
  
  chainChanged = new_chain => {
    this.setState(
      {
        selected_ticker:new_chain.ticker,
        selected_expiry:new_chain.expiry,
        selected_option_type:new_chain.option_type
      }
    )
  }


  // #region Fetch Data

  requestOptionData(ticker, expiry,width,option_type,strategy) {
    const url = `https://api.harsip.com/strategies/Verticals/${ticker}?expiry=${expiry}&width=${width}&strategy=${strategy}&option_type=${option_type}`
    //console.log(url)
    return (fetch(url)
        .then(res => res.json())
        .then((data) => {
          this.setState(
            { optiondata: data, displayed_ticker:ticker, displayed_width:width, displayed_expiry:expiry, displayed_option_type:option_type, displayed_strategy:strategy }
            ,()=>this.removeInvalidSpreads()
            ) 
        }).then(()=>{this.selectSpread(this.determineDefaultSelectedSpread())})
     .catch(console.log))
  }

 

   requestPriceData  (ticker) {
    let url = `https://api.harsip.com/ticker/${ticker}/prices`
    
    return fetch(url)
        .then(res => res.json())
        .then((data) => {
          this.setState({ pricedata: data }) 
        })
    // .catch(console.log)
  }

  // #endregion

  // #region sorting
  SortMode = {
    BottomStrike:0, TopStrike:1, Mark:2, MaxGain:3, MaxLoss:4, MaxROI:5
  }
  sortData(mode) {
      const data = this.state.optiondata

      switch (mode) {
  
        case this.SortMode.TopStrike:
          data.sort( (a,b) => b.topStrike - (a.topStrike)  )
          break
        case this.SortMode.Mark:
          data.sort( (a,b) =>  (b.mark) - (a.mark))
          break
          case this.SortMode.MaxGain:
            data.sort( (a,b) =>  (a.max_gain) - (b.max_gain))
            break
            case this.SortMode.MaxLoss:
              data.sort( (a,b) =>  (b.max_loss) - (a.max_loss))
              break
              case this.SortMode.MaxROI:
                data.sort( (a,b) =>  (parseFloat(b.max_roi) - parseFloat(a.max_roi)))
                break
                case this.SortMode.BottomStrike:
                default:
          data.sort( (a,b) => a.bottomStrike - b.bottomStrike )
      }
      this.setState({optiondata:data})
  }
  requestSort = (mode) => {
    this.sortData(mode)
    this.renderOptionsTable()
  }
  // #endregion
  
  removeInvalidSpreads() {
    const goodSpreads = []
    this.state.optiondata.forEach(s=>{
        if (s.mark < this.state.displayed_width) goodSpreads.push(s)
      }
    )
    return this.setState({optiondata:goodSpreads})
  }
  // #region selecting
  selectedSpread() {
    let data=this.state.optiondata  
    return data.find(spread=>{return spread.bottomStrike===this.state.selectedSpread})
  }  
  selectSpread = (selectedBottomStrike) => {
    this.setState({selectedSpread:selectedBottomStrike},()=>{this.renderOptionsTable(); this.renderChart()})
  }
  determineDefaultSelectedSpread() {
    const data = this.state.optiondata
    if ((data.length) > 1) 
      return data[1].bottomStrike
    else
      return data[0].bottomStrike
  }
  // #endregion

  // #region rendering components
  
  renderChart() {
    //if for some reason we don't have prices, skip this whole exercise...
    let pricedata = this.state.pricedata;
    if (pricedata===null) return;
   
    //build a series for the prices
    let price_series=  pricedata.map(p=>  { return  { x:Date.parse(p.time),y:p.close } });

    //get the first date in our price series
    let first_price_date = Math.min(...(price_series.map(p=>p.x)));

    let selectedSpread = this.selectedSpread();
    //build a series for each of the top and bottom strikes (2 points makes a line)
    let bottom_series =  [ {x:first_price_date,y:selectedSpread.bottomStrike}  , {x:Date.parse(this.state.displayed_expiry),y:selectedSpread.bottomStrike} ]  
    let top_series =  [ {x:first_price_date,y:selectedSpread.topStrike}  , {x:Date.parse(this.state.displayed_expiry),y:selectedSpread.topStrike} ]  
    
    //build the breakeven line
    const bePrice = (this.state.displayed_option_type==parseInt(OptionType.Call))?selectedSpread.bottomStrike+selectedSpread.mark:selectedSpread.topStrike-selectedSpread.mark
    let be_series =  [ {x:first_price_date,y:bePrice}  , {x:Date.parse(this.state.displayed_expiry),y:bePrice} ]
    
    var chartdata = { 
      series: [
        {name:'price',data:price_series},
        {name:'top',data:top_series},
        {name:'be',data:be_series},
        {name:'bottom',data:bottom_series}
      ] 
    }

    //skip the rest at build time
    if (typeof window == `undefined`) {return;}

    //require this here - it's chokes the build
    const Chartist = require("../plugins/bower_components/chartist/chartist.min.js")

    /*
      Figure out which strike represents max loss and which is max gain
    */  
    const bottomStrikeIsShort = ( 
      (this.state.displayed_strategy==parseInt(OptionStrategy.CreditSpread) && this.state.displayed_option_type == parseInt(OptionType.Call)) ||
      (this.state.displayed_strategy==parseInt(OptionStrategy.DebitSpread) && this.state.displayed_option_type == parseInt(OptionType.Put))
    )

    let lossunder_series = 'be'; let profitunder_series = 'top';
    if (bottomStrikeIsShort) {
      lossunder_series='top' ;
      profitunder_series='be';
    }
  
    const chartOptions = { 
      fullWidth: true,
      height:500,
      axisX: {
        type: Chartist.FixedScaleAxis,
        divisor: 12 ,
        //high: Date.parse(this.state.expiry),  
        labelInterpolationFnc: function(value) {
          return new Date(value).toLocaleString('en', {  month: 'short', day: 'numeric' })
        }
      },
      series: {
        'bottom': {showArea: false,showPoint: false},
        'top': {showArea: true,showPoint: false},
        'be': {showArea: true,showPoint: false}
      },
      plugins: [
        ctPartialArea({
          beline: bePrice,
          cutoffline: selectedSpread.bottomStrike,
          profitunder:profitunder_series,lossunder:lossunder_series
          },Chartist)
      ]
      }

      new Chartist.Line('.ct-chart', chartdata,chartOptions);
   }

   renderOptionsTable()  {
    const data=this.state.optiondata  
    const selectedSpreadStyle = {
      backgroundColor:'#545b62',
      color: '#ffffff'
    }
    const optiondatatable= (
      <table width="100%" className="table"  >
      <thead>
        <tr>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.BottomStrike)}>Bottom Strike&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.TopStrike)}>Top Strike&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.Mark)}>Mark&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.MaxGain)}>Max Gain&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.MaxLoss)}>Max Loss&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.MaxROI)}>Max ROI&nbsp;<i className="fas fa-sort"></i></th>
          </tr>
      </thead>
      <tbody id="spreadRows">
      {
        data.map(opt=> {
          //if (opt.mark>=this.state.displayed_width) return <></>

          return (<tr key={opt.bottomStrike}
            style={ (opt.bottomStrike===this.state.selectedSpread) ? selectedSpreadStyle : {}  }
            onClick={()=>this.selectSpread(opt.bottomStrike)}
          >
          <td>{opt.bottomStrike}</td>
          <td>{opt.topStrike}</td>
          <td>{formatCurrency(opt.mark)}</td>
          <td>{formatCurrency(opt.max_gain)}</td>
          <td>{formatCurrency(opt.max_loss)}</td>
          <td>{formatPct(opt.max_roi*100)}</td>
          </tr>)
        })
      }
      </tbody>
      </table>
   
    )
    ReactDOM.render(optiondatatable, document.getElementById('optionTable'));

  }
  // #endregion


  

  explainerBlurbForPage =<div>
  Spread Finder makes it easy to see, at a glance, all possible <OutboundLink href="https://www.investopedia.com/terms/v/verticalspread.asp">vertical spreads</OutboundLink> on a specific stock for a given expiration and width ('size' of spread).
  Then visualize the profit, loss, and breakeven points overlaid on top of the stock's recent price history
  </div>  

/* legendBlurb = <div>
 <img src={spreadLegendImg} alt="Visualizer legend" style={{borderWidth:"1px",borderColor:"#cccccc",borderStyle:"solid"}}/>
 </div> */

  render() {
    const selectedSpread = this.selectedSpread()
    let spreadDetail = <></>
    let legendBlurb = <></>
    //let option_type_name = ''
    
    if (this.state.resultsVisible===true) {
      const bottomStrikeIsShort = ( 
        (this.state.displayed_strategy==parseInt(OptionStrategy.CreditSpread) && this.state.displayed_option_type == parseInt(OptionType.Call)) ||
        (this.state.displayed_strategy==parseInt(OptionStrategy.DebitSpread) && this.state.displayed_option_type == parseInt(OptionType.Put))
      )
      const costOrCredit = (this.state.displayed_strategy==parseInt(OptionStrategy.CreditSpread)) ? "Credit" : "Cost"
      const breakevenAboveOrBelow = (bottomStrikeIsShort)?"below":"above"
      const breakevenPrice = (this.state.displayed_option_type==parseInt(OptionType.Call))?selectedSpread.bottomStrike+selectedSpread.mark:selectedSpread.topStrike-selectedSpread.mark

      const instructions = (bottomStrikeIsShort) ? 
          <>Sell the <b>{selectedSpread.bottomStrike}</b> strike<br/>Buy the <b>{selectedSpread.topStrike}</b> strike</>
        : <>Buy the <b>{selectedSpread.bottomStrike}</b> strike<br/>Sell the <b>{selectedSpread.topStrike}</b> strike</>
      
      spreadDetail = <div>
        {optionName(this.state.displayed_option_type)} {strategyName(this.state.displayed_strategy)}:<br/>{instructions}
        <br/>
        {costOrCredit}: {formatCurrency(selectedSpread.mark)}<br/>
        Max Gain: {formatCurrency(selectedSpread.max_gain)} (ROI: {formatPct(selectedSpread.max_roi*100)})<br/> 
        Breakeven at <b>{formatCurrency(breakevenPrice)}</b> (profit {breakevenAboveOrBelow})
      </div>

      legendBlurb =      
     <svg width="220" height="120">
        <rect width="100" height="40" className="loss_zone"/>
        <rect width="100" height="40" y="40" className="profit_zone"/>
        <text x="2" y="15"  className="font-light">Loss Zone</text>
        <text x="2" y="55"  className="font-light">Profit Zone</text>
        <text x="2" y="100" className="font-light">Breakeven Line</text>
        <line x1="0" y1="110" x2="100" y2="110" stroke="blue"  strokeWidth="1px"/>
      </svg>
    }
    
  return (
   
    <Ample currPageTitle="Vertical Spread Finder" explainerBlurb={this.explainerBlurbForPage}>
    <div className="white-box">
    <Backdrop style={{zIndex:  1,color: '#fff',}} open={this.state.backdropActive}  >
      <CircularProgress color="inherit" />
    </Backdrop>
    
        <div className="row">
          <ChainPicker 
            onChainChanged={this.chainChanged} 
            defaultTicker={this.state.selected_ticker}
            />
        </div>
        <div className="row">

        <button id="go" disabled={!this.formValid()} onClick={this.formSubmitted}  type="submit"  className="btn btn-rounded btn-default btn-outline">
              <i className="fas fa-play-circle  m-r-5"></i>Show</button>
            <button id="clear"  disabled={!this.state.resultsVisible} onClick={this.formReset} className="btn btn-rounded btn-default btn-outline" >
            <i className="fas fa-eraser  m-r-5"></i>Clear</button>

        <TextField  type="number"
                    label="Strike Width" id="spreadWidth"
                    value={this.state.strikewidth}
                    onChange={this.strikeWidthChanged}
                    variant="outlined"
                    helperText="Select spread width"/>
          <RadioGroup  value={parseInt(this.state.selected_strategy)} onChange={this.strategyChanged} name="spreadTypeSelector" id="spreadTypeSelector">
                        <FormControlLabel  value={OptionStrategy.CreditSpread} control={<Radio  />} label="Credit Spread"  />
                        <FormControlLabel value={OptionStrategy.DebitSpread} control={<Radio />} label="Debit Spread" />
                        </RadioGroup>
            
        </div>
           
         
        
      
                 
                  
       

      </div>

          <br />

      <div className="row justify-content-center">
          
          <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="card" id="optionTableContainer" style={{visibility:(this.state.resultsVisible)?'visible':'hidden'}}>
                <div className="card-body">
                  <h3>Spreads</h3>
                  <div className="card-subtitle">Vertical {optionName(this.state.displayed_option_type)} {strategyName((this.state.displayed_strategy))} for <b>{this.state.displayed_ticker}</b> on <b>{this.state.displayed_expiry}</b></div>
                  <div id="optionTable" className="table-responsive"></div>
                </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 col-xs-12">
            
            <div className="row justify-content-center">
              <div className="col-lg-12 col-sm-12 col-xs-12">
                
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div className="card" id="spreadContainer" style={{maxHeight:'200px',minHeight:'200px',visibility:(this.state.resultsVisible)?'visible':'hidden'}}>
                      <div className="card-body">
                        <h3 >Spread Detail</h3>
                        {spreadDetail}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                    <div className="card" id="legend" style={{maxHeight:'200px',minHeight:'200px',visibility:(this.state.resultsVisible)?'visible':'hidden'}}>
                      <div className="card-body">
                        <h3 >Legend</h3>
                        {legendBlurb}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-12 col-sm-12 col-xs-12">
                <div className="card" id="chartContainer" style={{visibility:(this.state.resultsVisible)?'visible':'hidden'}}>
                  <div className="card-body">
                    <h3 >Visualizer <ExplainerPopover>
                    Chart depicts the last 3 months of prices for {this.state.displayed_ticker}, and includes the time until the option expires ({this.state.displayed_expiry}).<br/>Overlaid on top are the profit and loss zones and breakeven point for the selected spread
                    </ExplainerPopover>
                    </h3>
                    <div id="chartArea" className="ct-chart"></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </div>
    </Ample>
    
  )
  }

  

}


